import { Platform } from "react-native";

export const platformConstants = {
	WEB: "web",
	IOS: "ios",
	ANDROID: "android",
	NATIVE: "native"
};

const HelperPlatform = {
	isWeb: () => {
		return Platform.OS === platformConstants.WEB
	},
	isNotWeb: () => {
		return !HelperPlatform.isWeb()
	},
	isNative: () => {
		return HelperPlatform.isAndroid() || HelperPlatform.isIOS()
	},
	isNotNative: () => {
		return !HelperPlatform.isNative()
	},
	isIOS: () => {
		return Platform.OS === platformConstants.IOS
	},
	isAndroid: () => {
		return Platform.OS === platformConstants.ANDROID
	},
	isIpad: () => {
		return Platform.isPad;
	},
	select: ( options ) => {
		if ( options[ 'ipad' ] && HelperPlatform.isIpad() ) {
			return options[ 'ipad' ];
		}
		
		return Platform.select( options );
	}
}

export default HelperPlatform
